import React, { useEffect, useState } from "react";
import {
  Card,
  Typography,
  DatePicker,
  Col,
  Layout,
  Row,
  List,
  Image,
  Carousel,
  Skeleton,
  Pagination,
  Drawer,
  Button,
  Tag,
} from "antd";
import type { Dayjs } from "dayjs";
import MenuBar from "../../components/Menu/MenuBar";
import Footer from "../../components/Footer/Footer";
import SearchAnnouncementsForm from "../../components/Forms/SearchAnnouncementsForm";
import useAnnouncementsSearch from "../../../hooks/announcements-hook";
import { Announcement, Events, PageSetting, Query } from "../..";
import { useNavigate, useParams } from "react-router-dom";
import { findById } from "../../../controllers/store/actions/announcement/update-announcement-actions";
import store from "../../../controllers/store";
import { useSelector } from "react-redux";
import { DownloadOutlined } from "@ant-design/icons";

const formatter = new Intl.NumberFormat("es-ES", {
  style: "currency",
  currency: "COP", // Cambia a 'USD', 'COP', etc., según la moneda que necesites.
});
const { Content } = Layout;
const { RangePicker } = DatePicker;
const { Title, Text } = Typography;
const query: Query = { filter: {} };
const dispatch = store.dispatch;
export default function AnnouncementSListings() {
  const navigate = useNavigate();
  const { announcementId } = useParams(); // A
  const { result, searchAnnouncements } = useAnnouncementsSearch();
  const [isListView, setIsListView] = useState(true);
  const [pageAnnouncement, setpageAnnouncements] = useState<number>(0);
  const [searchText, setSearchText] = useState("");
  const [selectedDateRange, setSelectedDateRange] = useState<
    [Dayjs | null, Dayjs | null]
  >([null, null]);
  const [organizer, setOrganizer] = useState("");
  const updatedAnnouncementState = useSelector(
    (state: any) => state.updatedAnnouncement
  );

  const [open, setOpen] = useState(false);

  const showDrawer = () => {
    setOpen(true);
  };

  const detail = (params: any) => {
    if ((params.id ? params.id : params).toString() === announcementId) {
      return showDrawer();
    }
    navigate(`/announcements-listing/${params.id ? params.id : params}`);
  };

  const onClose = () => {
    setOpen(false);
  };

  useEffect(() => {
    if (announcementId) {
      console.log("parametro dimanico ", announcementId);
      dispatch(findById(announcementId));
      showDrawer();
    }
  }, [announcementId]);

  useEffect(() => {
    searchAnnouncements(
      "announcement",
      {
        filter: `&filter[visibility_end_date][_gt]=${new Date().toISOString()}&filter[status][_eq]=Published`,
      },
      1,
      PageSetting.limit
    );
  }, [searchText]);

  const renderListItem = (announcement: Announcement) => (
    <List.Item onClick={() => detail(announcement)}>
      <List.Item.Meta
        avatar={
          announcement.image && (
            <Image
              src={announcement.image}
              alt={announcement.nombre}
              width={400}
              height={200}
              style={{ objectFit: "cover", borderRadius: "8px" }}
              preview={false}
            />
          )
        }
        title={<Text strong>{announcement.nombre}</Text>}
        description={
          <>
            <Text type="secondary">
              <strong>Fechas:</strong> {announcement.visibility_start_date} -{" "}
              {announcement.visibility_end_date}
            </Text>
            <br />
            <Text>
              <strong>Descripción:</strong> {announcement.descripcion_breve}
            </Text>
            <br />
            {announcement.presupuesto && (
              <Text>
                <strong>Presupuesto:</strong>{" "}
                {formatter.format(announcement.presupuesto)}
              </Text>
            )}
            <br />
            {announcement.tecnologias && (
              <Text>
                <strong>Tecnologías:</strong> {announcement.tecnologias}
              </Text>
            )}
            <br />
            {announcement.tipo_organizacion && (
              <Text>
                <strong>Organización:</strong> {announcement.tipo_organizacion}
              </Text>
            )}

            <br />
            {announcement.responsable && (
              <Text>
                <strong>Responsable:</strong> {announcement.responsable}
              </Text>
            )}
            <br />
            {announcement.institucion && (
              <Text>
                <strong>Institución:</strong> {announcement.institucion}
              </Text>
            )}
          </>
        }
      />
    </List.Item>
  );

  const renderGridCard = (announcement: Announcement) => (
    <Card
      onClick={() => detail(announcement.id)}
      hoverable
      cover={
        announcement.image && (
          <Image
            src={announcement.image}
            alt={announcement.nombre}
            height={200}
            style={{ objectFit: "cover", borderRadius: "8px" }}
            preview={false}
          />
        )
      }
    >
      <Card.Meta
        title={announcement.nombre}
        description={
          <div>
            <Text>
              <strong>Descripción:</strong> {announcement.descripcion_breve}
            </Text>
            <br />
            {announcement.presupuesto && (
              <Text>
                <strong>Presupuesto:</strong>{" "}
                {formatter.format(announcement.presupuesto)}
              </Text>
            )}
            <br />
            <Text>
              <strong>Fechas:</strong> {announcement.visibility_start_date} -{" "}
              {announcement.visibility_end_date}
            </Text>
            <br />
            {announcement.tecnologias && (
              <Text>
                <strong>Tecnologías:</strong> {announcement.tecnologias}
              </Text>
            )}
            <br />
            {announcement.tipo_organizacion && (
              <Text>
                <strong>Organización:</strong> {announcement.tipo_organizacion}
              </Text>
            )}
          </div>
        }
      />
    </Card>
  );

  return (
    <Layout className="events-listings-layout">
      <Drawer
        title="Detalle de convocatoria"
        width={720}
        onClose={onClose}
        open={open}
        styles={{
          body: {
            paddingBottom: 80,
          },
        }}
      >
        <Skeleton
          loading={updatedAnnouncementState.isLoading}
          active
          className="full-width"
        >
          {updatedAnnouncementState &&
            updatedAnnouncementState.announcement && (
              <div>
                <Image
                  src={updatedAnnouncementState.announcement.image}
                  alt={updatedAnnouncementState.announcement.nombre}
                  style={{ width: "100%", marginBottom: "16px" }}
                  preview={false}
                />
                <Title level={4}>
                  {updatedAnnouncementState.announcement.nombre}
                </Title>
                <Text strong>Descripción detallada:</Text>
                <p>
                  {updatedAnnouncementState.announcement.descripcion_detallada}
                </p>
                <Text strong>Presupuesto:</Text>{" "}
                {formatter.format(
                  updatedAnnouncementState.announcement.presupuesto
                )}
                <br />
                <Text strong>Expectativas de solución:</Text>
                <p>
                  {updatedAnnouncementState.announcement.expectativas_solucion}
                </p>
                <Text strong>Requisitos obligatorios:</Text>
                <p>
                  {
                    updatedAnnouncementState.announcement
                      .requisitos_obligatorios
                  }
                </p>
                <Text strong>Requisitos deseables:</Text>
                <p>
                  {updatedAnnouncementState.announcement.requisitos_deseables}
                </p>
                <Text strong>Requisitos no deseables:</Text>
                <p>
                  {
                    updatedAnnouncementState.announcement
                      .requisitos_no_deseables
                  }
                </p>
                <Text strong>Tecnologías:</Text>
                <p>{updatedAnnouncementState.announcement.tecnologias}</p>
                <Text strong>Áreas:</Text>{" "}
                {updatedAnnouncementState.announcement.areas.map(
                  (area: any) => (
                    <>
                      <br />
                      <Tag color="#2db7f5">
                        {area.AREA_DE_CONOCIMIENTO_id.AREA_DE_CONOCIMIENTO}
                      </Tag>
                      <br />
                    </>
                  )
                )}
                <br />
                <Text strong>Subáreas:</Text>{" "}
                {updatedAnnouncementState.announcement.sub_areas.map(
                  (subarea: any) => (
                    <>
                      <br />
                      <Tag color="#2db7f5">
                        {
                          subarea.ESPECIALIDAD_DE_CONOCIMIENTO_id
                            .ESPECIALIDAD_DE_CONOCIMIENTO
                        }
                      </Tag>
                      <br />
                    </>
                  )
                )}
                <br />
                <Text strong>Organización:</Text>{" "}
                {updatedAnnouncementState.announcement.tipo_organizacion}
                <br />
                <br />
                <br />
                {updatedAnnouncementState.announcement.url ? (
                  <Col span={24}>
                    <Button
                      type="primary"
                      size={"large"}
                      onClick={() => {
                        console.log(
                          "updatedAnnouncementState.announcement.url",
                          updatedAnnouncementState.announcement
                        );
                        if (updatedAnnouncementState.announcement.url) {
                          window.open(
                            updatedAnnouncementState.announcement.url,
                            "_blank"
                          );
                        }
                      }}
                    >
                      Abrir URL de convocatoria
                    </Button>
                  </Col>
                ) : null}
                <br />
                {updatedAnnouncementState.announcement.document ? (
                  <Col span={24}>
                    <Button
                      type="primary"
                      icon={<DownloadOutlined />}
                      size={"large"}
                      onClick={() => {
                        if (updatedAnnouncementState.announcement.document) {
                          window.open(
                            `${process.env.REACT_APP_API_ASSETS}${updatedAnnouncementState.announcement.document.id}`,
                            "_blank"
                          );
                        }
                      }}
                    >
                      Descargar presentación
                    </Button>
                  </Col>
                ) : null}
              </div>
            )}
        </Skeleton>
      </Drawer>
      <MenuBar />
      <Skeleton loading={result.loading} active className="full-width">
        {/* Carousel */}
        <Carousel autoplay>
          {result.values.map((announcement) => (
            <div>
              <Image
                onClick={() => {
                  if (announcement.url) {
                    window.open(announcement.url, "_blank");
                  }
                }}
                src={announcement.image}
                alt={announcement.nombre}
                width="100%"
                height={450}
                style={{ objectFit: "cover" }}
                preview={false}
              />
            </div>
          ))}
        </Carousel>
      </Skeleton>
      <Content className="bg-gray-50">
        <div style={{ padding: "40px" }}>
          <div className="max-w-7xl mx-auto">
            <div className="mb-8">
              <Title
                level={2}
                style={{
                  color: "#ff6b00",
                  borderLeft: "4px solid #ff6b00",
                  paddingLeft: "16px",
                }}
              >
                Convocatorias
              </Title>
            </div>
            <br />
          </div>
          <SearchAnnouncementsForm
            onDateRangeSelect={(dates: [Dayjs | null, Dayjs | null]) => {
              setSelectedDateRange(dates);
              if (!dates) {
                delete query.filter.visibility_start_date;
              } else {
                query.filter.visibility_start_date = `&filter[visibility_start_date][_between]=${dates[0]?.format(
                  "YYYY-MM-DD"
                )},${dates[1]?.format("YYYY-MM-DD")}&`;
              }
            }}
            onSearch={function (value: string): void {
              if (!value) {
                delete query.filter.search;
              } else {
                query.filter.search = `&search=${value}&`;
              }
              searchAnnouncements("announcement", query, 1, PageSetting.limit);
            }}
            onSearchPressEnter={function (value: any): void {
              if (!value) {
                delete query.filter.search;
              } else {
                query.filter.search = `&search=${value}&`;
              }

              searchAnnouncements("announcement", query, 1, PageSetting.limit);
            }}
            onChangeViewLayout={function (value: boolean): void {
              setIsListView(value);
            }}
          />
          {/* Events Display */}
          <Skeleton loading={result.loading} active className="full-width">
            <br />
            <br />
            <br />
            <div className="max-w-5xl mx-auto p-4">
              {isListView ? (
                <List
                  itemLayout="vertical"
                  dataSource={result.values}
                  renderItem={renderListItem}
                />
              ) : (
                <Row gutter={[16, 16]}>
                  {result.values.map((announcement: Announcement) => (
                    <Col key={announcement.id} xs={24} sm={12} md={8}>
                      {renderGridCard(announcement)}
                    </Col>
                  ))}
                </Row>
              )}
            </div>
          </Skeleton>
        </div>
        <br />
        <Row gutter={[8, 8]} style={{ width: "100%", textAlign: "center" }}>
          <Col xs={24} sm={12} md={8} lg={24}>
            <Pagination
              showSizeChanger={false}
              pageSize={PageSetting.limit}
              current={pageAnnouncement}
              defaultCurrent={PageSetting.page}
              total={result.pagination?.total}
              onChange={async (page, pageSize) => {
                searchAnnouncements(
                  "announcement",
                  query,
                  page,
                  PageSetting.limit
                );
                setpageAnnouncements(page);
              }}
            />
          </Col>
        </Row>
        <br />
        <br />
      </Content>
      <Footer />
    </Layout>
  );
}
